import React, { useMemo, useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import CustomPagination from "../common/CustomPagination";
import "./PaperSpotTab.scss";
import useInput from "../hooks/useInput";
import usePagination from "../hooks/usePagination";
import { roundNumber } from "../../utils/Utils";
import DefaultPagination from "../common/DefaultPagination";

const PaperSpotTab = (props) => {
  const { totalSpot } = props;
  const coins = props.coins || [];
  const [rangeItems, bindPagination] = usePagination(0, 10);
  const [hideSmall, setHideSmall] = useState(false);
  const [search, bindSearch] = useInput("");
  const filterCoins = useMemo(() => {
    return coins
      .filter(
        (el) =>
          !search.length || el.name.toLowerCase().includes(search.toLowerCase())
      )
      .filter((el) => !hideSmall || (hideSmall && el.balance_usd > 10));
  }, [search, hideSmall, coins]);
  const coinItems = filterCoins.slice(...rangeItems).map((el, id) => {
    return (
      <tr key={id} className="theme-border">
        <td className="text-left pl-4">
          <img src={el.image} width={20} />
          <span className="ml-2">{el.name}</span>
        </td>
        <td>{(el.total || 0).toFixed(6)}</td>
        <td>{(el.free || 0).toFixed(6)}</td>
        <td>{(el.used || 0).toFixed(6)}</td>
        <td>{(el.balance_usd || 0).toFixed(6)}</td>
      </tr>
    );
  });
  return (
    <div className="spot-tab">
      <Row noGutters className="pt-3">
        <Col>
          <div className="title">Total Balance</div>
          <div className="value">{(totalSpot || 0).toFixed(6)} USD</div>
        </Col>
        <Col className="hide-small">
          <Form.Check
            type="checkbox"
            label="Hide Small Balance"
            value={hideSmall}
            onChange={(e) => setHideSmall(Boolean(e.target.checked))}
          />
        </Col>
        <Col className="search-box">
          <Form.Control placeholder="Search Symbol" {...bindSearch} />
        </Col>
      </Row>
      <Table className="my-4 theme-bg" responsive borderless>
        <thead>
          <tr>
            <th className="text-left pl-5">Symbol</th>
            <th>Total Amount</th>
            <th>Available</th>
            <th>Reserved</th>
            <th>USD Balance</th>
          </tr>
        </thead>
        <tbody>{coinItems}</tbody>
      </Table>
      <DefaultPagination {...bindPagination} totalCount={filterCoins.length} />
    </div>
  );
};

export default PaperSpotTab;
